<template>
  <div id="choiceItems">
    <ChoiceNavigation></ChoiceNavigation>
    <br>
    <Datatable
      v-if="inventory"
      entity="choice_item"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[
        {text: 'choiceItems.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
        {text: 'display_priority', method: goToDisplayPriority, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import ChoiceNavigation from '@/components/choices/Navigation.vue';
  import { mapActions } from "vuex";

  export default {
    name: "choiceItems",

    components: { ChoiceNavigation, Datatable },

    data() {
      return {
        entityName: 'choice_items'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      }
    },

    async created() {
      this.$store.state.pageTitleTranslationKey = "inventory.choice_items";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      edit(id) {
        this.$router.push({ path: '/choice-items/edit', query : Object.assign({ id : id, inventory: this.inventory.id }, this.$route.query) });
      },
      onCreate() {
        this.edit(null)
      },
      goToDisplayPriority() {
        this.$router.push({ path: '/choice-items/priority', query : Object.assign({inventory: this.inventory.id }, this.$route.query) });
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({ entity: this.entityName, inventory: this.inventory.id, id: row.id });
        this.$refs.datatable.query();
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>
